import { cn } from "@/lib/utils";

type Variant = "info" | "success" | "warn" | "quote";

const VARIANT_STYLES: Record<Variant, string> = {
  info: "border-primary/30 bg-primary/5 text-foreground",
  success: "border-emerald-200 bg-emerald-50 text-emerald-900",
  warn: "border-amber-200 bg-amber-50 text-amber-900",
  quote:
    "border-l-4 border-l-primary border-y-0 border-r-0 bg-transparent text-foreground rounded-none pl-6 italic",
};

export function Callout({
  variant = "info",
  title,
  children,
}: {
  variant?: Variant;
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn("rounded-lg border px-4 py-3 text-sm leading-relaxed", VARIANT_STYLES[variant])}
    >
      {title && <div className="font-semibold mb-1">{title}</div>}
      <div>{children}</div>
    </div>
  );
}
